import {endOfWeek, format, isValid, parse, startOfWeek} from 'date-fns';

export var isDate = function (date) {
    return (new Date(date) !== "Invalid Date") && !isNaN(new Date(date));
}

export function formatDate(date) {
    if (!date || date === '0000-00-00 00:00:00' || date === '0000-00-00') return '';

    const hasTime = date.includes(' ');
    const dateTimeString = hasTime ? new Date(date) : new Date(date + 'T00:00:00');
    const padDate = (item) => String(item).padStart(2, '0');
    let dateStr = `${padDate(dateTimeString.getDate())}/${padDate(dateTimeString.getMonth() + 1)}/${padDate(dateTimeString.getFullYear())}`;

    if (hasTime) {
        dateStr += ` ${padDate(dateTimeString.getHours())}:${padDate(dateTimeString.getMinutes())}`;
    }

    return dateStr;
}

export function toDateOnly(str) {
    const dateObj = new Date(str);
    return (dateObj.getUTCDate()) + "/" + (dateObj.getMonth() + 1) + "/" + (dateObj.getUTCFullYear())
}

export function toDateTime(str) {
    const dateObj = new Date(str);
    return (dateObj.getUTCDate()) + "/" + (dateObj.getMonth() + 1) + "/" + (dateObj.getUTCFullYear()) + " " + dateObj.getHours() + ":" + (dateObj.getMinutes() < 10 ? '0' + dateObj.getMinutes() : dateObj.getMinutes())
}

export function toTimeOnly(str) {
    const dateObj = new Date(str);
    return dateObj.getHours() + ":" + (dateObj.getMinutes() < 10 ? '0' + dateObj.getMinutes() : dateObj.getMinutes());
}

export function tryParseDate(str) {
    if (!isInt(str) && isDate(str)) {
        return toDateOnly(str);
    }

    return str;
}

function isInt(value) {
    return !isNaN(value) && (function (x) {
        return (x | 0) === x;
    })(parseFloat(value))
}

export function convertToDecimalNumber(number) {
    return number?.toFixed(2);
}

export function addDays(dateToAddDays, noOfDays) {
    dateToAddDays.setDate(dateToAddDays.getDate() + noOfDays);

    return dateToAddDays;
}

export function subtractDays(dateToAddDays, noOfDays) {
    dateToAddDays.setDate(dateToAddDays.getDate() - noOfDays);
    return dateToAddDays;
}

export function dateToString(date, formatString = 'dd/MM/yyyy') {
    let formattedDate = '';

    if (date && isDate(date)) {
        formattedDate = format(date, formatString);
    }

    return formattedDate;
}

export function checkFutureEventFromPurchaseStart(event, purchaseStartDate = null) {
    if (event) {
        const eventStartDate = new Date(event.event_start);
        let currentDate = new Date();

        if (purchaseStartDate) {
            currentDate = purchaseStartDate;
        }

        currentDate.setHours(0, 0, 0, 0);

        return eventStartDate >= currentDate;
    }

    return false;
}

export function getWeekStartEndDate(date) {
    let start = startOfWeek(date, {weekStartsOn: 1});
    let end = endOfWeek(date, {weekStartsOn: 6});

    start = format(start, 'yyyy-MM-dd');
    end = format(end, 'yyyy-MM-dd');

    return {"from": start, "to": end};
}

export function parseDDMMYYYY(dateString) {
    if (!dateString || typeof dateString !== 'string') return null;

    const parts = dateString.split('/');
    if (parts.length !== 3) return null;

    const day = parseInt(parts[0], 10);
    const month = parseInt(parts[1], 10) - 1; // Months are 0-indexed in JS
    const year = parseInt(parts[2], 10);

    // Validate the numbers
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;

    const date = new Date(year, month, day);

    // Check if the date is valid and matches the input
    if (date.getDate() === day && date.getMonth() === month && date.getFullYear() === year) {
        return date;
    }

    return null;
}

export function getFutureDate(daysFromNow) {
    const date = new Date();
    date.setDate(date.getDate() + daysFromNow);
    date.setHours(0, 0, 0, 0);
    return date;
}

export const formatTime = (timeStr) => {
    if (!timeStr) return "";
    try {
        // Handle HH:mm:ss, HH:mm, or ISO datetime
        const parsed = parse(timeStr, "HH:mm:ss", new Date());
        if (isValid(parsed)) return format(parsed, "HH:mm");
        const parsedShort = parse(timeStr, "HH:mm", new Date());
        if (isValid(parsedShort)) return timeStr; // Already HH:mm
        return "";
    } catch {
        return "";
    }
};